import React from 'react';
import { Helmet } from 'react-helmet';

export const MetaTags: React.FC = () => {
  return (
    <Helmet>
      <title>Theo Goodman - Software Engineer, Product Manager & Entrepreneur</title>
      <meta name="description" content="Software engineer, product manager, and entrepreneur. I build solutions to life's problems. Currently leading product & technology at Half Lemons." />
      <meta name="author" content="Theo Goodman" />
      <meta name="keywords" content="Theo Goodman, Software Developer, Product Manager, iOS Developer, Half Lemons, Tech Entrepreneur" />
      
      {/* Theme Color */}
      <meta name="theme-color" content="#FFFFFF" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.hellogoodman.com/" />
      <meta property="og:title" content="Theo Goodman - Software Engineer, Product Manager & Entrepreneur" />
      <meta property="og:description" content="Software engineer, product manager, and entrepreneur. I build solutions to life's problems. Currently leading product & technology at Half Lemons." />
      <meta property="og:image" content="https://www.hellogoodman.com/images/theo-open-graph.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Theo Goodman" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@theojeffgood" />
      <meta name="twitter:url" content="https://www.hellogoodman.com/" />
      <meta name="twitter:title" content="Theo Goodman - Software Engineer, Product Manager & Entrepreneur" />
      <meta name="twitter:description" content="Software engineer, product manager, and entrepreneur. I build solutions to life's problems. Currently leading product & technology at Half Lemons." />
      <meta name="twitter:image" content="https://www.hellogoodman.com/images/theo-open-graph.jpg" />
      
      {/* Canonical URL */}
      <link rel="canonical" href="https://www.hellogoodman.com/" />
    </Helmet>
  );
}; 